import Vue from "vue"
import { Component } from "vue-property-decorator"
import { utils } from "./utils"

@Component({})
export default class UtilsMixin extends Vue {
	public copyToClipboard (element: HTMLElement, text: string) {
		return utils.methods.copyToClipboard(element, text)
	}

	public pluralize (str: string) {
		return utils.methods.pluralize(str)
	}

	public sanitizeForCss (text: string) : string {
		return utils.methods.sanitizeForCss(text)
	}

	public async isOnline () : Promise<boolean> {
		return utils.methods.isOnline()
	}
}
